import React from "react";

import { Column, Row, useCurrentViewPort, ViewPort } from "@gamedev-web/gamedev-sdk-core";

import { FormattedText } from "../FormattedText";
import * as styles from "./ProgramSelector.module.css";
import { ProgramColumnConfig } from "./programSelectorUtils";

type AttributesTableProps = Readonly<{
  columnsConfig: ProgramColumnConfig[];
  programId: string;
  useFormattedText?: boolean;
}>;

const renderAttributeDescription = (title: string, content: string, useFormattedText: boolean) => (
  <Row>
    <Column>
      <p className={styles.descriptorTitle}>{title}</p>
      {useFormattedText ? (
        <FormattedText className={styles.descriptorContent} text={content} />
      ) : (
        <p className={styles.descriptorContent}>{content}</p>
      )}
    </Column>
  </Row>
);

export const AttributesTable = ({
  columnsConfig,
  programId,
  useFormattedText = false,
}: AttributesTableProps) => {
  const currentViewPort = useCurrentViewPort();

  if (currentViewPort < ViewPort.MD) {
    return (
      <>
        {columnsConfig.map(config =>
          renderAttributeDescription(config.title, config.content, useFormattedText)
        )}
      </>
    );
  }

  return (
    <Row>
      {columnsConfig.map((config, index) => (
        <Column
          className={config.doubleSizedColumn ? styles.doubleColumn : ""}
          key={`${programId}-${index}`}
        >
          {renderAttributeDescription(config.title, config.content, useFormattedText)}
        </Column>
      ))}
    </Row>
  );
};
